import React from 'react';
import { useSelector } from 'react-redux';

export default function useBankSelector() {
  const BankViewData = useSelector((state) => state.Bank.view_data?.bankOpsEntity) || {}; // view data
  const BankListData = useSelector((state) => state.Bank.list_data?.bankOpsList?.content) || []; // view data
  return { BankViewData, BankListData };
}
